'use client';

import { useContentfulLiveUpdates } from '@contentful/live-preview/react';
import Image from 'next/image';
import ContactCTA from '@/components/ContactCTA';
import ContactNew from '@/components/ContactNew';
import Content from '@/components/Content';
import FrequentlyAskedQuestions from '@/components/FrequentlyAskedQuestions';
import Header from '@/components/Header';
import Testimonials from '@/components/Testimonials';
import { Markdown } from '@/lib/markdown';
import { IHomepage } from '@/models/homepage';
import { INewsResponse } from '@/models/news';
import CallToAction from '@/components/CallToAction';

export default function HomePage({
	homepageData,
	blogs,
	preview = false,
}: {
	homepageData: IHomepage;
	blogs: INewsResponse;
	preview?: boolean;
}) {
	const homepage = homepageData;

	if (!homepage) {
		return null;
	}

	return (
		<section className="-mt-16">
			<div className="z-20 relative bg-contain xl:bg-cover bg-white text-white bg-bottom  flex flex-col">
				<Header
					headerDescription={homepage?.header?.contentDescription}
					title={homepage?.header?.title}
					headerSliderImagesCollection={homepage?.headerImagesCollection}
				/>
			</div>

			<div className="bg-primary-500 text-white relative py-12 md:py-32 flex flex-col gap-8 md:gap-28  z-auto">
				<CallToAction
					className="[&_p]:xl:text-2xl [&_p]:lg:text-xl [&_p]:text-lg "
					description={homepage.callToAction?.contentDescription}
					title={homepage.callToAction?.title}
					caption={homepage.callToAction?.caption}
					image={homepage.callToAction?.image}
					buttons={homepage.callToAction?.buttonsCollection?.items}
					iconList={homepage.callToAction?.iconListCollection?.items}
					imageCover={homepage.callToAction?.imageCover}
				/>
			</div>

			<div className="relative black py-12 pb-0 bg-transparent flex flex-col gap-8 md:gap-28 bg-white -mt-[31vw] md:-mt-[330px] lg:-mt-[450px] z-20 pt-[31vw] md:pt-[270px] lg:pt-[450px]">
				<div className="flex flex-col gap-4 md:gap-8  overflow-hidden">
					{homepage?.contentCollection?.items?.map((content, index) => {
						return (
							<Content
								key={index}
								description={content.contentDescription}
								title={content?.title}
								caption={content?.caption}
								image={content?.image}
								buttons={content?.buttonsCollection?.items}
								iconList={content?.iconListCollection?.items}
								imageCover={content?.imageCover}
								reverse={content?.reverse}
							/>
						);
					})}
				</div>
			</div>

			<div className="relative z-20 bg-white">
				<Testimonials />
			</div>

			<ContactCTA
				title={homepage.callToActionTwo?.title}
				description={
					homepage.callToActionTwo?.contentDescription && (
						<Markdown content={homepage.callToActionTwo.contentDescription} />
					)
				}
				buttons={homepage.callToActionTwo?.buttonsCollection?.items}
			/>

			{!!homepage?.faqsCollection?.items?.length ? (
				<div className="z-10 relative py-12  md:py-32 flex flex-col overflow-clip bg-white">
					<FrequentlyAskedQuestions
						faqs={homepage?.faqsCollection?.items}
						title={'Frequently Asked Questions'}
					/>
				</div>
			) : null}
		</section>
	);
}
